/**************************************************
 * Nombre:       Tarjeta_Personal
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Avatar, Button, Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";


const Tarjeta_Personal = ({click, item}) => {

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Avatar src={item.img} sx={{width: 96, height: 96}}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{color: theme.palette.primary.main, fontWeight: 800}}>{item.nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 1}}>
                <Typography sx={{fontSize: 14, fontWeight: 400}}>{item.cargo}</Typography>
            </Grid>

            <Grid container size={{xs: 10, sm: 8, md: 8}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{
                    fontSize: 12, fontWeight: 300, textAlign: 'center',
                    textOverflow: "ellipsis",
                    display: '-webkit-box',
                    overflow: 'hidden',
                    WebkitBoxOrient: 'vertical',
                    WebkitLineClamp: 3
                }}>
                    {item.descripcion}
                </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 3}}>
                <Button onClick={() => click(item)} variant={'outlined'}>Ver Mas</Button>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Personal    